export default "__VITE_ASSET__FDWqxI2U__"